import { useSelector } from 'react-redux';
import { selectClientName } from 'redux/config/config.selectors';

export const usePageTitle = title => {
  const clientName = useSelector(selectClientName);

  return `${clientName} | ${title}`;
};
